import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { CommonPageHeader } from 'inside-out/components/about-us/commonPageHeader';
import { ArrowLink } from 'inside-out/components/shared/arrowLink';

import {
	wrapperStyle,
	innerWrapperStyle,
	imgStyle,
	titleStyle,
	ContentStyle,
} from 'inside-out/page-styles/about-us/what-we-do';

export default class WhatWeDoPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							blocks: PropTypes.arrayOf(
								PropTypes.shape({
									heading: PropTypes.string,
									image: PropTypes.string,
									body: PropTypes.string,
									link_text: PropTypes.string,
									link_destination: PropTypes.string,
								})
							),
						}),
					})
				),
			}),
		}),
	};

	render() {
		const { blocks } = this.props.data.page.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet title="About Us : What we do">
				  <meta property="og:type" content="website"/>
				  <meta property="og:title" content="About Us : What we do"/>
				  <meta name="description" content="InsideOut is Australia’s national institute for research and clinical excellence in eating disorders with global research partnerships. We aim to transform the treatment landscape for eating disorders in Australia, and ultimately find a cure."/>
				  <meta property="og:description" content="InsideOut is Australia’s national institute for research and clinical excellence in eating disorders with global research partnerships. We aim to transform the treatment landscape for eating disorders in Australia, and ultimately find a cure."/>
				</Helmet>

				{CommonPageHeader}

				{blocks.map((block, index) => (
					<section key={index} className={innerWrapperStyle}>
						<div className={imgStyle}>
							<img src={block.image} alt="" />
						</div>
						<div className={ContentStyle}>
							<h1 className={titleStyle}>{block.heading}</h1>

							<div dangerouslySetInnerHTML={{ __html: block.body }} />

							{block.link_destination &&
								block.link_text && (
									<p>
										<ArrowLink to={block.link_destination}>{block.link_text}</ArrowLink>
									</p>
								)}
						</div>
					</section>
				))}
			</div>
		);
	}
}

export const query = graphql`
	query AboutUsWhatWeDoPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/about-us-what-we-do-page\\.json/" } }) {
			edges {
				node {
					blocks {
						heading
						image
						body
						link_text
						link_destination
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/about-us/what-we-do/index.js